import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import SelectPile from '../SelectPile';
import ContextMenu from '../ContextMenu';
import { selectChoosingEnergies, selectEnergyAttachmentIds } from './selectors';
import { chooseBenchPosition } from './actions';
import { RETREAT } from '../ActiveGame/contextMenuTypes';
import { selectActivePokemon } from '../ActiveGame/selectors';

/** Choosing which attached energy pays the retreat cost. */
const RetreatContextMenu = ({ userId }) => {
  const dispatch = useDispatch();
  const activePokemon = useSelector((state) => selectActivePokemon(state, { userId }));
  const choosingEnergies = useSelector(selectChoosingEnergies);
  const energyAttachmentIds = useSelector(selectEnergyAttachmentIds);

  if (!choosingEnergies || !activePokemon) {
    return null;
  }

  const count = activePokemon.getIn(['card', 'retreat_cost']);

  return (
    <ContextMenu menu={RETREAT} userId={userId} title="Retreat">
      <SelectPile
        cardsOrCardables={activePokemon.get('energyAttachments')}
        message={`Choose ${count === 1 ? 'the energy' : `${count} energy cards`} to discard, then pick who switches in.`}
        selectCount={count}
        selectedIds={energyAttachmentIds}
        onSelectDone={(ids) => dispatch(chooseBenchPosition(ids))}
      />
    </ContextMenu>
  );
};

RetreatContextMenu.propTypes = {
  userId: PropTypes.number.isRequired,
};

export default RetreatContextMenu;
